import { ContentRenderer } from '@p2p/components';
import { type TGetOrderResponse } from '@p2p/services';
import { formatCurrencyAmount, formatPhoneNumber } from '@p2p/shared/functions';
import { useDeviceDetect } from '@p2p/shared/hooks';
import classNames from 'classnames';
import { FC } from 'react';

import styles from '../../styles.module.scss';
import { InfoBlock } from './InfoBlock';
import innerStyles from './TransferInstruction.module.scss';

interface ITransferInstructionProps {
  order: TGetOrderResponse;
  content: string;
  onClose: () => void;
}

export const TransferInstruction: FC<ITransferInstructionProps> = ({ order, content, onClose }) => {
  const { isMobile } = useDeviceDetect();
  const components = {
    PhoneNumber: <InfoBlock value={formatPhoneNumber(order.requisite.phone_number || '')} />,
    Bank: <InfoBlock value={order.requisite.bank.name || 'Банк не найден'} />,
    PaymentAmount: (
      <InfoBlock
        value={`${formatCurrencyAmount(order.expected_income || 0)} ${
          order.currency_code_to || ''
        }`}
        copyValue={formatCurrencyAmount(order.expected_income || 0)}
      />
    ),
    AccountNumber: <InfoBlock value={order.requisite.account_number || ''} />,
    CardNumber: <InfoBlock value={order.requisite.account_number || ''} />,
    BIC: <InfoBlock value={order.requisite.bic || ''} />,
  };

  return (
    <div className={classNames(styles.payment_instruction, innerStyles.container)}>
      {!isMobile && (
        <div className={styles.payment_dialog__header_title}>
          Инструкция по оплате
          <div className={styles.payment_dialog__header_hide} onClick={onClose}>
            Скрыть
          </div>
        </div>
      )}
      <div className={styles.instuction_separator} />
      <div className={styles.payment_instruction__content}>
        <ContentRenderer htmlString={content} replacements={components} />
      </div>
    </div>
  );
};
